<template>
  <div class="Login">
    <Loading v-if="loading" />
    <div class="f-1">
      <div class="content-sm">
        <div class="LoginButtons">
          <router-link id="LinkGoToLogin" to="/login" class="title active">Giriş Yap</router-link>
          <router-link id="LinkGoToRegister" to="/register" class="title passive">Üye Ol</router-link>
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="onSubmit">
            <ValidationProvider name="E-Posta" rules="required" v-slot="{ errors }">
              <div class="mb-60" :class="{'with-error': errors[0]}">
                <Input
                  id="InputEmailTC"
                  placeholder="E-Posta veya T.C. Kimlik Numaranız"
                  v-model="email"
                />
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider name="Şifre" rules="required" v-slot="{ errors }">
              <div class="mb-40" :class="{'with-error': errors[0]}">
                <PasswordInput id="InputPassword" placeholder="Şifreniz" v-model="password" />
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <div class="d-flex a-center mb-20">
              <Switcher id="SwitchRemember" v-model="remember">Beni Hatırla</Switcher>
              <router-link
                id="LinkGoToForgotPassword"
                to="/forgot-password"
                class="ml-auto"
              >Şifremi Unuttum</router-link>
            </div>
            <button
              id="BtnContinue"
              type="submit"
              @click="onSubmit"
              :disabled="disabled||invalid"
            >Giriş Yap</button>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <div class="separator">
      <span>veya</span>
    </div>
    <div class="f-1">
      <QRCode />
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  components: {
    Switcher: () => import("../lib/components/Switcher"),
    QRCode: () => import("../lib/components/QRCode"),
    Input: () => import("../lib/components/Input"),
    PasswordInput: () => import("../lib/components/PasswordInput"),
    Loading: () => import("../lib/components/Loading")
  },
  data: () => ({
    loading: true,
    remember: false,
    email: "",
    password: ""
  }),
  computed: {
    disabled() {
      return !this.email || !this.password;
    }
  },
  methods: {
    onSubmit() {
      this.$router.push("/select-card");
    }
  }
};
</script>